/*
 * @Author: xiaowei
 * @Date: 2020-04-21 15:09:40
 * @LastEditors: xiaowei
 * @LastEditTime: 2020-04-24 11:03:44
 * @Description: file content
 */
import api from '@/api'
import chatUtil from '@/store/chat/chat/utils'
import common from '@/common'

export default {
    initChatData(store) {     // 初始化存在localStorage中的state
        let newChatSession: any = window.localStorage ? window.localStorage.getItem('newChatSession') : null
        if (newChatSession) {
            window.localStorage.removeItem('newChatSession')
            newChatSession = JSON.parse(newChatSession)
            let activeId = chatUtil.returnSessionId(newChatSession.yunxinAccId)
            store.dispatch('chat/setCurrSession', activeId)
            store.commit('chat/resetNoMoreHistoryMsgs')
            let newSession = {
                id: activeId,
                avatar: newChatSession.icon,
                contactName: newChatSession.userName,
                updateTime: Date.now(),
            }
            store.commit('chat/updateSessions', [newSession])
        }
    },
    goChat({state}, {detail, type}) {
        api.cs_yunxin_info({
            userId: detail.id,
            userName: detail.name,
            userSystem: 'peanut',
            identityOwner: type === 'employer' ? 'web' : 'app',
            userType: type === 'employer' ? 'employer' : 'helper',
        }).then(({data}) => {
            window.localStorage.setItem('newChatSession', JSON.stringify(data))
            if (state.chatWin && state.chatWin.location.reload) {
                state.chatWin.location.reload()
            }
            state.chatWin = window.open('/easy/chat', 'managerChatWin')
        })
    },
    logout({commit}, {isRequiredLog}) {
        return api.user_logout(null, {})
            .then(() => {
                commit('SET_LOGGED', false)
                common.removeToken()
                window.localStorage.removeItem('notificationList')
                window.localStorage.removeItem('referensh')
                window.localStorage.removeItem('changeCompany')
                window.localStorage.removeItem('noCompany')
                window.localStorage.removeItem('userCompanyInfo')
                if (isRequiredLog) {
                    setTimeout(() => {
                        window.location.href = '/easy/login'
                    }, 2000)
                } else {
                    window.location.href = '/easy/login'
                }
            })
    },
}
